// src/utils/dateRangeUtils.ts
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth } from 'date-fns';

/**
 * Get start and end dates for a week containing the given date
 * @param date The reference date
 * @param weekStartsOn First day of week (0 = Sunday, 1 = Monday, etc.)
 * @returns Tuple of [startDate, endDate]
 */
export const getWeekRange = (
  date: Date, 
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0
): [Date, Date] => {
  return [
    startOfWeek(date, { weekStartsOn }),
    endOfWeek(date, { weekStartsOn })
  ];
};

/**
 * Get start and end dates for a month containing the given date
 * @param date The reference date
 * @returns Tuple of [startDate, endDate]
 */
export const getMonthRange = (date: Date): [Date, Date] => {
  return [
    startOfMonth(date),
    endOfMonth(date)
  ];
};

/**
 * Format a date range as a string for debugging
 * @param startDate Start date
 * @param endDate End date
 * @returns Formatted string
 */
export const formatDateRangeForDebug = (startDate: Date, endDate: Date): string => {
  return `${startDate.toISOString().split('T')[0]} to ${endDate.toISOString().split('T')[0]}`;
};